export default {
    payment_received: 'btn-primary',
    cancel: 'btn-danger',
    refunded: 'btn-primary',
    label_printed: 'btn-primary',
    refund: 'btn-warning',
    ready_for_shipment: 'btn-primary',
    delivery_failed: 'btn-danger',
    imprint_received: 'btn-primary',
    cancelled: 'btn-danger',
    images_received: 'btn-primary',
    images_ok: 'btn-primary',
    images_not_ok: 'btn-danger',
    at_least_one_imprint_visually_ok: 'btn-primary',
    both_imprints_visually_not_ok: 'btn-danger',
    cannot_be_treated: 'btn-danger',
    set_returned: 'btn-primary',
    imprints_scanned: 'btn-primary',
    both_imprints_scan_ok: 'btn-primary',
    at_least_one_imprint_scan_not_ok: 'btn-danger',
    physician_assigned: 'btn-primary',
    case_uploaded: 'btn-primary',
    treatment_setup_done: 'btn-primary',
    treatment_plan_done: 'btn-primary',
    treatment_plan_ok_for_physician: 'btn-primary',
    treatment_plan_not_ok_for_physician: 'btn-danger',
    treatment_quotation_created: 'btn-primary',
    park_treatment: 'btn-warning',
    treatment_sold: 'btn-primary',
    imprints_received: 'btn-primary',
    treatment_parked: 'btn-warning',
    send_reminder: 'btn-primary',
    sepa_mandate_created: 'btn-primary',
    payments_received: 'btn-primary',
    put_payment_on_hold: 'btn-warning',
    continue_reminder: 'btn-primary',
    aligners_ordered: 'btn-primary',
    aligners_received: 'btn-primary',
    aligners_shipped: 'btn-primary',
    aligners_returned: 'btn-danger',
    aligners_delivered: 'btn-primary',
    delivery_problem_solved: 'btn-primary',
    follow_up_call_made: 'btn-primary',
    send_email: 'btn-primary',
    repeal: 'btn-danger',
    stop: 'btn-danger',
    in_delivery: 'btn-primary',
    images_not_available: 'btn-danger',
    solvency_check_passed: 'btn-primary',
    solvency_check_failed: 'btn-danger',
    invoice_uploaded_to_zab: 'btn-primary',
    images_forwarded: 'btn-primary',
    feedback_forwarded: 'btn-primary',
    ok: 'btn-primary',
    not_ok: 'btn-danger',
    appointment_made: 'btn-primary',
    setup_done: 'btn-primary',
    refine_setup: 'btn-danger',
    pretreatment_needed: 'btn-primary',
    plan_done: 'btn-primary',
    refine_plan: 'btn-danger',
    production_files_uploaded: 'btn-primary',
    models_printed: 'btn-primary',
    thermo_formed: 'btn-primary',
    aligners_produced: 'btn-primary',
    produced: 'btn-primary',
    aligner_shipped: 'btn-primary',
    ipr_declined: 'btn-danger',
    x_ray_needed: 'btn-danger',
        request_medical_evaluation: 'btn-danger',
}



// WEBPACK FOOTER //
// ./src/modules/process/state/task-detail/event-color.js